function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "transparent",
  d: "M-179-1481H969v12372H-179z"
}), React.createElement("path", {
  d: "M7.21 50.52l2.236-6.918.952.308-3.096 9.58-6.58-7.62.757-.654 4.751 5.503-1.202-5.938C.923 21.208 5.318 6.415 18.294.544l.412.912C6.236 7.096 1.978 21.433 6.011 44.596l1.2 5.924z",
  fill: "#333745",
  fillRule: "nonzero"
}));

var SvgLongArrow = function SvgLongArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 54,
    viewBox: "0 0 19 54",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLongArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/longArrow.6a187733.svg";
export { ForwardRef as ReactComponent };